$(document).ready(function () {
  $(".open-menu .item-submenu").on('click', function(){
    $('.open-menu').slideUp();
  })

  $(".icon-menu").on("click", function () {
    $(".open-menu").slideDown()
  });

  $(".close-menu").on("click", function () {
    closeMenu();
  });

  $('.search-content .search-form').on({
    focusout: function (e) {
      $(".search-content").slideUp(500);
    },
    focusin: function (e) {
      console.log("focusin");
    }
  });

  $(".icon-search").on("click", function () {
    openSearchContent()
  });

  $(".search-link").on("click", function () {
    closeMenu();
    openSearchContent()
  });

  function openSearchContent(){
    $(".search-content").slideDown(500);
    $(".search-content .search-input").focus();
  }

  function closeMenu(){
    $(".open-menu").slideUp();
  }

  $(".item-menu").on("click", function () {closeMenu()})
});
